'use strict'

url = do ->
  href = location.href.split('/')

  localRegex = /^\d+\.\d+\.\d+\.\d+/
  workRegex = /^.*\/pc\/[^\/]+\/.*$/

  for val , i in href
    if val is '' or i is href.length - 1 and val.indexOf('.')
      href.splice(i,1)

  if localRegex.test(location.hostname) is true or location.hostname.indexOf('localhost') isnt -1
    length = 2

  else if workRegex.test(location.href) is true
    length = 3

    for val , i in href
      if val is 'pc' and href[i-1] is 'work'
        length = 4

  else
    length = 1

  path = ''

  for j in [0..(length)]
    path += href[j]

    if j is 0
      path += '//'

    else
      path += '/'

  return path

resizeFlg = {}
resizeFlg.pc = true
resizeFlg.sp = true
firstView = ''

ps = ''

caseSlide = ()->
  $('.p-case .js-slide').slick({
    autoplay: true,
    autoplaySpeed: 5000,
    speed: 900,
    initialSlide: 0,
    swipeToSlide: true,
    centerMode: true,
    variableWidth: true,
    dots: true,
    customPaging: (slick, index)->
      targetImage = url + 'img/pc/index_case_thumb_dot.png'
      return '<img src=" ' + targetImage + ' "/>'
    responsive: [
      {
        breakpoint: 751,
        settings: {
          centerMode: false,
          variableWidth: false,
          customPaging: (slick, index)->
            targetImage = url + 'img/sp/index_case_thumb_dot.png'
            return '<img src=" ' + targetImage + ' "/>'
        }
      }
    ]
  })

pickupSlide = ()->
  $('.p-pickup .activities .js-slide').slick({
    autoplay: true,
    fade: true,
    arrows: false
  })

caseSlide()

sp = ()->
  console.log('index:SP')

  $('.mainimg__main').slick({
    autoplay: true,
    autoplaySpeed: 5000,
    speed: 900,
    centerMode: true,
    variableWidth: true,
    swipeToSlide: true,
    dots: true
  })

  pickupSlide()

  $('.js-menu__button').on('click', ()->
    # if $('.slick-initialized').length > 0
    #   $('.js-slide').slick('unslick')

    # if not $('html').hasClass('is-fixed')
    #   caseSlide()
    #   pickupSlide()
  )

pc = ()->
  console.log('index:PC')

  $('.mainimg__main').slick({
    autoplay: true,
    autoplaySpeed: 5000,
    speed: 900,
    arrows: true,
    asNavFor: '.mainimg__sub',
  })

  $('.mainimg__sub').slick({
    autoplay: true,
    autoplaySpeed: 5000,
    speed: 900,
    slidesToShow: 6,
    centerMode: true,
    asNavFor: '.mainimg__main',
    focusOnSelect: true,
  })

  ps = new PerfectScrollbar('.p-blog__list')

if window.matchMedia('(max-width:750px)').matches
  # SP
  firstView = 'SP'

  sp()
else
  # PC
  firstView = 'PC'

  pc()

$(window).on('resize',
  ()->
    if window.matchMedia('(max-width:750px)').matches
      if firstView is 'PC' and resizeFlg.sp is true or
      firstView is false and resizeFlg.sp is true
      # PC から SP へ

        ps.destroy()
        ps = null

        sp()

        resizeFlg.pc = true
        resizeFlg.sp = false
        firstView = false
    else
      if firstView is 'SP' and resizeFlg.pc is true or
      firstView is false and resizeFlg.pc is true
      # SP から PC へ

        $('.p-pickup .activities .js-slide').slick('unslick')
        $('.js-menu__button').off('click')

        pc()

        resizeFlg.pc = false
        resizeFlg.sp = true
        firstView = false
)
